import React from 'react'
import './settings-style.scss'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import useReportsStyles from './styles'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import LogReport from '../LogReport'
import UserListing from '../UserListing'
import AddInternalUsers from './components/AddInternalUsers'
import InternalUserlist from '../InternalUserlist'
import AddExternalUserspage from './components/AddExternalUserspage/AddExternalUserspage'
import ChangePasswordPage from './components/ChangePasswordPage/ChangePasswordPage'
import UserInfo from './components/UserInfo/userInfo'
import EmailSettings from './components/EmailSettings'

const Settings = () => {
  const classes = useReportsStyles()
  const [userlistvalue, setUserlistvalue] = React.useState('1')
  const [userAddvalue, setUserAddvalue] = React.useState('1')
  const userType = localStorage.getItem('userType')
  const initialTabValue =
    userType === 'admin' || userType === 'sub_admin' ? '1' : '1'
  const [value, setValue] = React.useState(initialTabValue)
  const token = localStorage.getItem('accessToken')

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleUserlistTabChange = (event, newValue) => {
    setUserlistvalue(newValue)
  }

  const handleUserAddTabChange = (event, newValue) => {
    setUserAddvalue(newValue)
  }

  const adminTabsConfig = [
    { label: 'List of Users', value: '1' },
    { label: 'Add Users', value: '2' },
    { label: 'Log Report', value: '3' },
    { label: 'Change Password', value: '4' },
    { label: 'Email Settings', value: '5' },
  ]

  const userTabsConfig = [
    { label: 'User Info', value: '1' },
    { label: 'Change Password', value: '4' },
  ]

  const tabsToShow =
    userType === 'admin' || userType === 'sub_admin'
      ? adminTabsConfig
      : userTabsConfig

  return (
    <div className={classes.root}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <div className="graph_bg">
              <h5>Settings</h5>
              <hr />
              <Box>
                <Grid container spacing={2}></Grid>
                <div>
                  <TabContext value={value}>
                    <Box style={{ display: 'flex', minHeight: '400px' }}>
                      <Box className="page_h_b2" style={{ width: '20%' }}>
                        <TabList
                          onChange={handleTabChange}
                          aria-label="lab API tabs example"
                          orientation="vertical"
                          variant="scrollable"
                          sx={{
                            '&& .MuiTab-root': {
                              alignItems: 'baseline',
                            },
                          }}
                        >
                          {tabsToShow.map((tab) => (
                            <Tab
                              key={tab.value}
                              classes={{
                                root: 'MuiButtonBase-root-MuiTab-root',
                              }}
                              label={tab.label}
                              value={tab.value}
                              style={{
                                backgroundColor:
                                  value === tab.value
                                    ? 'rgb(85 164 242 / 11%)'
                                    : 'white',
                              }}
                            />
                          ))}
                        </TabList>
                      </Box>
                      <Box className="page_h_b2" style={{ width: '80%' }}>
                        {userType === 'admin' || userType === 'sub_admin' ? (
                          <>
                            <TabPanel value="1">
                              <Box
                                sx={{
                                  '& .MuiTextField-root': {
                                    m: 1,
                                    width: '100%',
                                  },
                                }}
                                md={8}
                                noValidate
                                autoComplete="off"
                              >
                                <TabContext value={userlistvalue}>
                                  <Box
                                    className="page_h_b2"
                                    style={{ width: '100%' }}
                                  >
                                    <TabList
                                      onChange={handleUserlistTabChange}
                                      aria-label="Userlist API tabs example"
                                    >
                                      <Tab
                                        classes={{
                                          root: 'MuiButtonBase-root-MuiTab-root',
                                        }}
                                        label="Internal Users"
                                        value="1"
                                      />
                                      <Tab
                                        classes={{
                                          root: 'MuiButtonBase-root-MuiTab-root',
                                        }}
                                        label="External Users"
                                        value="2"
                                      />
                                    </TabList>
                                  </Box>
                                  <Box
                                    className="page_h_b2"
                                    style={{ width: '100%' }}
                                  >
                                    <TabPanel value="1">
                                      <InternalUserlist />
                                    </TabPanel>
                                    <TabPanel value="2">
                                      <UserListing />
                                    </TabPanel>
                                  </Box>
                                </TabContext>
                              </Box>
                            </TabPanel>
                            <TabPanel value="2">
                              <Box
                                sx={{
                                  '& .MuiTextField-root': {
                                    m: 1,
                                    width: '100%',
                                  },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TabContext value={userAddvalue}>
                                  <Box
                                    className="page_h_b2"
                                    style={{ width: '100%' }}
                                  >
                                    <TabList
                                      onChange={handleUserAddTabChange}
                                      aria-label="Userlist API tabs example"
                                    >
                                      <Tab
                                        classes={{
                                          root: 'MuiButtonBase-root-MuiTab-root',
                                        }}
                                        label="Internal Users"
                                        value="1"
                                      />
                                      <Tab
                                        classes={{
                                          root: 'MuiButtonBase-root-MuiTab-root',
                                        }}
                                        label="External Users"
                                        value="2"
                                      />
                                    </TabList>
                                  </Box>
                                  <Box
                                    className="page_h_b2"
                                    style={{ width: '100%' }}
                                  >
                                    <TabPanel value="1">
                                      <AddInternalUsers
                                        handleTabChange={handleTabChange}
                                      />
                                    </TabPanel>
                                    <TabPanel value="2">
                                      <AddExternalUserspage
                                        handleTabChange={handleTabChange}
                                        handleUserlistTabChange={
                                          handleUserlistTabChange
                                        }
                                      />
                                    </TabPanel>
                                  </Box>
                                </TabContext>
                              </Box>
                            </TabPanel>
                            <TabPanel value="3">
                              <LogReport token={token} />
                            </TabPanel>
                            <TabPanel value="5">
                              <EmailSettings />
                            </TabPanel>
                          </>
                        ) : (
                          <TabPanel value="1">
                            <UserInfo />
                          </TabPanel>
                        )}
                        <TabPanel value="4">
                          <Box
                            sx={{
                              '& .MuiTextField-root': { mt: 1, width: '100%' },
                            }}
                            noValidate
                            autoComplete="off"
                          >
                            <ChangePasswordPage />
                          </Box>
                        </TabPanel>
                      </Box>
                    </Box>
                  </TabContext>
                </div>
              </Box>
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

export default Settings
